import './footer.component.scss';
import React from "react";

const Footer: React.FC<any> = () => {
    return (
        <div className="footer">
            <p>&copy; 2026 <a target="_blank" href="http://tatvamanalytics.com/">Cinchio Solutions, LLC</a>. All rights reserved.</p>
        </div>
    );
};

export default Footer;
